<template>
  <div class="section haze full-height">
    <div class="wrapper w-container">
      <div class="middle">
        <h5 class="green left">
          <strong>Step 2 of 3 | </strong
          ><span><strong class="bold-text-2">Plan Selection</strong></span>
        </h5>
      </div>
    </div>
    <div class="wrapper checkout-container w-container">
      <div v-if="isEditing" class="intro">
        <div class="text-label-2">No problem, lets get that fixed</div>
        <h2 class="volk">
          Select a New Plan for {{ currentPatient.first_name }}
        </h2>
        <div class="divider-2 animated" />
      </div>
      <div v-else class="intro">
        <div class="text-label-2">
          Okay {{ currentPatient.first_name }}, lets do this!
        </div>
        <h2 class="volk">Select Your Plan</h2>
        <div class="divider-2 animated" />
      </div>
      <div data-duration-in="400" data-duration-out="200" class="tabs w-tabs">
        <div class="tabs-menu-v2 less-margin-bottom w-tab-menu">
          <a
            data-w-tab="Tab 2"
            class="tab-link-v2 w-inline-block w-tab-link w--current"
            @click="tab('traditional')"
          >
            <div v-if="traditional">Traditional Plans</div>
            <div v-else>Child Plans</div>
          </a>
          <a
            v-if="traditional && company.company.is_pediatric_practice == 0 && perioPlans.length > 0"
            data-w-tab="Tab 4"
            class="tab-link-v2 w-inline-block w-tab-link"
            @click="tab('perio')"
          >
            <div>Perio Plans</div>
          </a>
        </div>
        <div class="full-width w-tab-content">
          <div
            data-w-tab="Tab 2"
            class="pricing-tab-content w-tab-pane w--tab-active"
          >
            <ul
              v-if="seniorDiscount || multiPatientDiscount"
              role="list"
              class="pricing-discount-text w-list-unstyled"
            >
              <li v-if="seniorDiscount" class="list-item discounts">
                <span v-if="seniorDiscount.application === 1">
                  Senior Discount Activated! - Save ${{
                    seniorDiscount.appropriation_amount | toMonetary
                  }}/Month - Savings applied at Checkout
                </span>
                <span v-else>
                  Senior Discount Activated! - Save
                  {{ seniorDiscount.percent_value }}%/Month - Savings applied at
                  Checkout
                </span>
              </li>
              <li v-if="multiPatientDiscount" class="list-item discounts">
                <span v-if="multiPatientDiscount.application === 1">
                  Multiple Patient Discount Activated! - Save ${{
                    multiPatientDiscount.appropriation_amount | toMonetary
                  }}/Month - Savings applied at Checkout
                </span>
                <span v-else>
                  Multiple Patient Discount Activated! - Save
                  {{ multiPatientDiscount.percent_value }}%/Month - Savings
                  applied at Checkout
                </span>
              </li>
            </ul>
            <div
              v-if="traditional"
              data-w-id="bbee6f9d-e2a0-e36b-f4ac-043098f26855"
            >
              <div class="w-layout-grid main-grid frequency-wrapper">
                <div
                  v-for="plan in [...traditionalPlans].sort((a, b) => b.frequency - a.frequency)"
                  :key="plan.id"
                  data-w-id="bbee6f9d-e2a0-e36b-f4ac-043098f2685c"
                  :class="getCssClassByFrequency(plan)"
                  :style="[
                    selected
                      ? { 'box-shadow': getCssStylePlanSelected(plan) }
                      : '',
                  ]"
                >
                  <a href="#" @click="selectPlan(plan)">
                    <div class="html-embed frequency-text-dark w-embed">
                      <p :style="{ fontSize: getFontSize(plan), fontWeight: 'bold', lineHeight: '1.4', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }">
                        {{ plan.display_name }}
                      </p>
                    </div>
                    <div class="div-block frequency-shaded">
                      <!-- <div v-if="plan.frequency === 6" class="most-popular">
                        Most Popular!
                      </div> -->
                      <div class="w-embed">
                        <p
                          style="color: white; margin-top: 24px;"
                          v-if="company.company.suppress_monthly_payment_option"
                        >
                          $
                          <span
                            style="font-size: 40px; font-weight: bold"
                            v-if="plan.annual_base_price"
                            >{{ plan.annual_base_price | toMonetary }}</span
                          >
                          <span
                            style="font-size: 40px; font-weight: bold"
                            v-else
                            >{{ (plan.base_price * 12) | toMonetary }}</span
                          >
                          Per Year
                        </p>
                        <p style="color: white; margin-top: 24px;" v-else>
                          $
                          <span style="font-size: 40px; font-weight: bold">{{
                            plan.base_price | toMonetary
                          }}</span>
                          Per Month
                        </p>
                      </div>
                      <a href="#" class="button ghost pricing-box w-button"
                        >Select</a
                      >
                    </div>
                  </a>
                </div>
              </div>
              <!-- <div class="w-layout-grid main-grid frequency-wrapper">
                <div
                  v-for="plan in [...traditionalSemiAnnualPlans].sort((a, b) => b.frequency - a.frequency)"
                  :key="`${plan.id}-semiannual`"
                  data-w-id="bbee6f9d-e2a0-e36b-f4ac-043098f2685c"
                  :class="getCssClassByFrequency(plan)"
                  :style="[
                    selected
                      ? { 'box-shadow': getCssStylePlanSelected(plan) }
                      : '',
                  ]"
                >
                  <a href="#" @click="selectPlan(plan)">
                    <div class="html-embed frequency-text-dark w-embed">
                      <p>Visit Us</p>
                      <p>
                        Every
                        <span style="font-size: 40px; font-weight: bold">{{
                          plan.frequency
                        }}</span>
                        Months
                      </p>
                    </div>
                    <div class="div-block frequency-shaded">
                      <div class="frequency-caption">
                        Up to ${{ plan | toRewards }}/Year in Rewards!
                      </div>
                      <div class="w-embed">
                        <p style="color: white">
                          $
                          <span style="font-size: 40px; font-weight: bold">{{
                            plan.semiannual_base_price | toMonetary
                          }}</span>
                          Semi-Anually
                        </p>
                      </div>
                      <a href="#" class="button ghost pricing-box w-button"
                        >Select</a
                      >
                    </div>
                  </a>
                </div>
              </div>
              <div class="w-layout-grid main-grid frequency-wrapper">
                <div
                  v-for="plan in [...traditionalAnnualPlans].sort((a, b) => b.frequency - a.frequency)"
                  :key="`${plan.id}-semiannual`"
                  data-w-id="bbee6f9d-e2a0-e36b-f4ac-043098f2685c"
                  :class="getCssClassByFrequency(plan)"
                  :style="[
                    selected
                      ? { 'box-shadow': getCssStylePlanSelected(plan) }
                      : '',
                  ]"
                >
                  <a href="#" @click="selectPlan(plan)">
                    <div class="html-embed frequency-text-dark w-embed">
                      <p>Visit Us</p>
                      <p>
                        Every
                        <span style="font-size: 40px; font-weight: bold">{{
                          plan.frequency
                        }}</span>
                        Months
                      </p>
                    </div>
                    <div class="div-block frequency-shaded">
                      <div class="frequency-caption">
                        Up to ${{ plan | toRewards }}/Year in Rewards!
                      </div>
                      <div class="w-embed">
                        <p style="color: white">
                          $
                          <span style="font-size: 40px; font-weight: bold">{{
                            plan.annual_base_price | toMonetary
                          }}</span>
                          Anually
                        </p>
                      </div>
                      <a href="#" class="button ghost pricing-box w-button"
                        >Select</a
                      >
                    </div>
                  </a>
                </div>
              </div> -->
            </div>

            <div
              v-else
              data-w-id="bbee6f9d-e2a0-e36b-f4ac-043098f26855"
              class="w-layout-grid main-grid frequency-wrapper"
            >
              <div
                v-for="plan in [...childPlans].sort((a, b) => b.frequency - a.frequency)"
                :key="plan.id"
                data-w-id="bbee6f9d-e2a0-e36b-f4ac-043098f2685c"
                :class="getCssClassByFrequency(plan)"
                :style="[
                  selected
                    ? { 'box-shadow': getCssStylePlanSelected(plan) }
                    : '',
                ]"
              >
                <a href="#" @click="selectPlan(plan)">
                  <div class="html-embed frequency-text-dark w-embed">
                    <p :style="{ fontSize: getFontSize(plan), fontWeight: 'bold', lineHeight: '1.4', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }">
                      {{ plan.display_name }}
                    </p>
                  </div>
                  <div class="div-block frequency-shaded">
                    <!-- <div v-if="plan.frequency === 6" class="most-popular">
                      Most Popular!
                    </div> -->
                    <div class="w-embed">
                      <p style="color: white; margin-top: 24px;">
                        $
                        <span style="font-size: 40px; font-weight: bold">{{
                          plan.base_price | toMonetary
                        }}</span>
                        Per Month
                      </p>
                    </div>
                    <a href="#" class="button ghost pricing-box w-button"
                      >Select</a
                    >
                  </div>
                </a>
              </div>
            </div>
            <div class="activation-fee">
              + ${{
                (company.enrollment_fee + company.practice_enrollment_fee)
                  | toMonetary
              }}
              Enrollment Fee For Each Member
            </div>
          </div>
          <div
            data-w-tab="Tab 4"
            class="pricing-tab-content w-tab-pane"
            @click="tab"
          >
            <ul
              v-if="seniorDiscount || multiPatientDiscount"
              role="list"
              class="pricing-discount-text w-list-unstyled"
            >
              <li v-if="seniorDiscount" class="list-item discounts">
                <span v-if="seniorDiscount.application === 1">
                  Senior Discount Activated! - Save ${{
                    seniorDiscount.appropriation_amount | toMonetary
                  }}/Month - Savings applied at Checkout
                </span>
                <span v-else>
                  Senior Discount Activated! - Save
                  {{ seniorDiscount.percent_value }}%/Month - Savings applied at
                  Checkout
                </span>
              </li>
              <li v-if="multiPatientDiscount" class="list-item discounts">
                <span v-if="multiPatientDiscount.application === 1">
                  Multiple Patient Discount Activated! - Save ${{
                    multiPatientDiscount.appropriation_amount | toMonetary
                  }}/Month - Savings applied at Checkout
                </span>
                <span v-else>
                  Multiple Patient Discount Activated! - Save
                  {{ multiPatientDiscount.percent_value }}%/Month - Savings
                  applied at Checkout
                </span>
              </li>
            </ul>
            <div
              data-w-id="bbee6f9d-e2a0-e36b-f4ac-043098f26855"
              class="w-layout-grid main-grid frequency-wrapper"
            >
              <div
                v-for="plan in [...perioPlans].sort((a, b) => b.frequency - a.frequency)"
                :key="plan.id"
                data-w-id="bbee6f9d-e2a0-e36b-f4ac-043098f2685c"
                :class="getCssClassByFrequency(plan)"
                :style="[
                  selected
                    ? { 'box-shadow': getCssStylePlanSelected(plan) }
                    : '',
                ]"
              >
                <a href="#" @click="selectPlan(plan)">
                  <div class="html-embed frequency-text-dark w-embed">
                    <p :style="{ fontSize: getFontSize(plan), fontWeight: 'bold', lineHeight: '1.4', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }">
                      {{ plan.display_name }}
                    </p>
                  </div>
                  <div class="div-block frequency-shaded">
                    <!-- <div v-if="plan.frequency === 6" class="most-popular">
                      Most Popular!
                    </div> -->
                    <div class="w-embed">
                      <p style="color: white; margin-top: 24px;">
                        $
                        <span style="font-size: 40px; font-weight: bold">{{
                          plan.base_price | toMonetary
                        }}</span>
                        Per Month
                      </p>
                    </div>
                    <a href="#" class="button ghost pricing-box w-button"
                      >Select</a
                    >
                  </div>
                </a>
              </div>
            </div>
            <div class="activation-fee">
              + ${{
                (company.enrollment_fee + company.practice_enrollment_fee)
                  | toMonetary
              }}
              Enrollment Fee For Each Member
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Util from "../../helpers/Util";

export default {
  name: "Signup2component",

  filters: {
    toMonetary: function (value) {
      return Util.ConvertRealToMonetaryZero(value);
    },
    toMonetaryDecimal: function (value) {
      return Util.ConvertRealToMonetaryZero(value);
    },
    toRewards: function (plan) {
      return (plan.rewards * (12 / plan.frequency)).toFixed(0);
    },
  },

  props: {
    currentPatient: {
      type: Object,
      default: null,
      required: true,
    },
    childPlans: {
      type: Array,
      default: null,
    },
    traditionalPlans: {
      type: Array,
      default: null,
    },
    traditionalAnnualPlans: {
      type: Array,
      default: null,
    },
    traditionalSemiAnnualPlans: {
      type: Array,
      default: null,
    },
    perioPlans: {
      type: Array,
      default: null,
    },
    seniorDiscount: {
      type: Object,
      default: null,
    },
    multiPatientDiscount: {
      type: Object,
      default: null,
    },
    traditional: {
      type: Boolean,
      default: true,
    },
    isEditing: {
      type: Boolean,
      default: false,
    },
    company: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      selected: false,
      perioTab: false,
    };
  },

  mounted() {
    console.log("traditional signup 2", this.traditionalPlans);
    console.log("perio signup 2", this.perioPlans);
    if (this.childPlans.length) {
      this.perioTab = false;
    } else if (!this.traditional) {
      this.perioTab = true;
    }

    window.Webflow && window.Webflow.destroy();
    window.Webflow && window.Webflow.ready();
    window.Webflow && window.Webflow.require("ix2").init();
    document.dispatchEvent(new Event("readystatechange"));

    if (this.currentPatient.plan) {
      this.selected = true;
    }
  },

  methods: {
    getCssClassByFrequency(plan) {
      if (plan.frequency === 6 || plan.frequency === 3) {
        return "feature-card frequency-blocks greenish";
      } else if (plan.frequency === 9 || plan.frequency === 4) {
        return "feature-card frequency-blocks blue";
      } else {
        return "feature-card frequency-blocks gold";
      }
    },

    getCssStylePlanSelected(plan) {
      if (plan.selected) {
        return "0 0 0 10px #ee645a";
      } else {
        return "none";
      }
    },

    selectPlan(plan) {
      this.selected = false;
      if (this.currentPatient.plan) {
        this.currentPatient.plan.selected = false;
      }
      this.currentPatient.plan = plan;
      console.log("CURRENT PATIENT:", this.currentPatient);
      plan.selected = true;
      this.selected = true;
      this.$localStorage.set(
        "currentPatient",
        JSON.stringify(this.currentPatient)
      );
    },

    tab(tabSelected) {
      console.log(tabSelected);
      if (this.traditional && !tabSelected.type) {
        if (tabSelected === "perio") {
          this.perioTab = true;
        } else {
          this.perioTab = false;
        }
      } else {
        if (!tabSelected.type) {
          this.perioTab = true;
        }
      }
    },
  },

  computed: {
    getFontSize() {
      return (plan) => {
        const text = plan.display_name;
        const baseSize = 25;
        const minSize = 16;
        const maxSize = 35;
        // Adjust these values based on your needs
        const maxLength = 20;
        const calculatedSize = baseSize * (maxLength / text.length);
        const adjustedSize = Math.min(maxSize, Math.max(minSize, calculatedSize * 0.9));
        return `${adjustedSize}px`;
      }
    }
  },
};
</script>

<style>
.active-plan {
  box-shadow: "0 0 0 10px #ee645a";
}
</style>
